import styled from 'styled-components';

export const IconsContent = styled.div`
  gap: 5px;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const AutomaticAnswerContent = styled.div`
  height: 15px;
  width: 15px;
  cursor: pointer;
`;

export const OL = styled.div`
  height: 15px;
  width: 15px;
  cursor: pointer;
`;  